import React, { Component } from "react";
import request from "superagent";
import jsonp from "superagent-jsonp";
import serialize from "form-serialize";
import { browserHistory } from "react-router";

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = { submitting: false };
  }
  componentDidMount() {
    const Ladda = require("ladda");
    Ladda.bind(this.refs.button);
    this.refs.email.focus();
  }
  handleSubmit = e => {
    this.setState({ submitting: true, success: false });
    e.preventDefault();
    const { form } = this.refs;
    this.formHash = serialize(form, { hash: true });
    this.subscribeUser(form.action, serialize(form));
  };
  subscribeUser = (url, query) => {
    request
      .get(url)
      .use(jsonp)
      .query(query)
      .end((err, res) => this.handleResponse(err, res));
  };
  handleResponse = (err, res) => {
    this.setState({
      submitting: false,
      success: true
    });
    console.log(err, res);

    // if (res) {
    //   setTimeout(() => {
    //     const base = "https://app.raunch.me/register?email=";
    //     const email = this.formHash["cm-kktrjd-kktrjd"];
    //     if (typeof window !== "undefined") {
    //       window.location.replace(`${base}${email}`);
    //     }
    //   }, 1500);
    // }
  };
  render() {
    const { submitting, success } = this.state;
    const { query } = this.props.location;
    if (success) {
      return <p>Sign up successful, we look forward to welcoming you soon.</p>;
    }
    return (
      <form
        action="https://raunch.createsend.com/t/i/s/kktrjd/"
        method="post"
        id="subForm"
        className="form"
        onSubmit={this.handleSubmit}
        ref="form"
      >
        <p className="hide">
          <label for="fielduhtjtl">Type</label>
          <select
            id="fielduhtjtl"
            name="cm-fo-uhtjtl"
            defaultValue={query.model ? "661086" : "661087"}
          >
            <option value="661087">viewer</option>
            <option value="661086">model</option>
          </select>
        </p>
        <p className="m0 relative input-wrapper">
          <input
            id="fieldEmail"
            name="cm-kktrjd-kktrjd"
            type="email"
            required
            placeholder="Email address"
            className="input border-box mb0"
            ref="email"
            autoFocus
          />
          <button
            type="submit"
            ref="button"
            className="btn btn-primary btn-big"
            disabled={submitting}
          >
            Sign up
          </button>
        </p>
      </form>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./components/Form.js